export default __webpack_public_path__ + "b2a950b595d4606c3b53fb84348e7c5f.png";